export const MAX_MEDICATION_LENGTH = 10;
